<template>
  <v-card class="pa-4 mb-4" elevation="0" rounded="lg">
    <div class="d-flex flex-wrap align-center justify-space-between gap-4">
      <div>
        <h6 class="text-subtitle-1 font-weight-bold mb-1">Período do relatório</h6>
        <span class="text-caption text--secondary">
          {{ periodLabel }}
        </span>
      </div>

      <div class="d-flex flex-wrap align-center gap-2">
        <v-btn
          v-for="preset in presets"
          :key="preset.key"
          small
          rounded
          elevation="0"
          :color="activePreset === preset.key ? 'primary' : undefined"
          @click="applyPreset(preset.key)"
        >
          {{ preset.label }}
        </v-btn>

        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn small outlined rounded v-bind="attrs" v-on="on">
              <v-icon left small>mdi-calendar-range</v-icon>
              Personalizar
            </v-btn>
          </template>
          <v-date-picker
            v-model="pickerDates"
            range
            no-title
            scrollable
            :max="today"
            locale="pt-br"
            @change="onPickerChange"
          />
        </v-menu>
      </div>
    </div>
  </v-card>
</template>

<script>
import moment from "moment";

export default {
  name: "DashboardPeriodFilter",
  props: {
    value: {
      type: Object,
      default: () => ({ start: null, end: null }),
    },
  },
  data() {
    return {
      menu: false,
      activePreset: "7d",
      pickerDates: [],
      presets: [
        { key: "today", label: "Hoje" },
        { key: "7d", label: "7 dias" },
        { key: "30d", label: "30 dias" },
        { key: "month", label: "Mês atual" },
      ],
    };
  },
  computed: {
    today() {
      return moment().format("YYYY-MM-DD");
    },
    periodLabel() {
      if (!this.value?.start || !this.value?.end) return "";
      const start = moment(this.value.start).format("DD/MM/YYYY");
      const end = moment(this.value.end).format("DD/MM/YYYY");
      return `${start} — ${end}`;
    },
  },
  mounted() {
    if (!this.value?.start) {
      this.applyPreset("7d");
    } else {
      this.pickerDates = [
        moment(this.value.start).format("YYYY-MM-DD"),
        moment(this.value.end).format("YYYY-MM-DD"),
      ];
    }
  },
  methods: {
    emitPeriod(start, end, preset = "custom") {
      this.activePreset = preset;
      const startMoment = moment(start).startOf("day");
      const endMoment = moment(end).endOf("day");
      this.$emit("input", {
        start: startMoment.toISOString(),
        end: endMoment.toISOString(),
      });
    },
    applyPreset(key) {
      const end = moment().endOf("day");
      let start;

      switch (key) {
        case "today":
          start = moment().startOf("day");
          break;
        case "7d":
          start = moment().subtract(6, "days").startOf("day");
          break;
        case "30d":
          start = moment().subtract(29, "days").startOf("day");
          break;
        case "month":
          start = moment().startOf("month");
          break;
        default:
          return;
      }

      this.pickerDates = [start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD")];
      this.emitPeriod(start, end, key);
    },
    onPickerChange(dates) {
      if (!dates || dates.length < 2) return;
      const sorted = [...dates].sort();
      this.emitPeriod(sorted[0], sorted[1], "custom");
      this.menu = false;
    },
  },
};
</script>
